import { render } from "./vehiclesInventory.vue?vue&type=template&id=5871b770&scoped=true"
import script from "./vehiclesInventory.vue?vue&type=script&lang=js"
export * from "./vehiclesInventory.vue?vue&type=script&lang=js"

import "./vehiclesInventory.vue?vue&type=style&index=0&id=5871b770&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5871b770"]])

export default __exports__